import { Injectable } from '@angular/core';
import { BehaviorSubject, forkJoin, Observable } from 'rxjs';
import { ErrorHandlerService } from './error-handler.service';
import { Router, NavigationEnd } from '@angular/router';
import { EnterpriseTypeEnum } from '../enums/enterprise-type-enum';
import { LicenseAdditionalEnum } from '../enums/license-additional-enum';
import {
  EmployeeConfigDto,
  EmployeeRestService,
  EmployerDto,
  EnterpriseConfigV2Dto,
  EnterpriseDto,
  EnterpriseLicensesV2Dto,
  EnterpriseRestService,
  RetailerConfigV2Dto,
  RetailerRestService,
  UserGrantDto,
} from '../api/exa';
import { AuthService } from './auth.service';
import { NGXLogger } from 'ngx-logger';
import { ExaGrant } from '../model/exa-grant';
import { NavUrls } from '../enums/nav-urls';
import { PartnerConnectionTypEnum } from '../enums/partnerconnection-type-enum';

@Injectable({
  providedIn: 'root',
})
export class EmployerService {
  public selectedEmployer$ = new BehaviorSubject<EmployerDto>(null);
  private selectedEmployerFirst$ = new BehaviorSubject<EmployerDto>(null);
  public selectedEmployer: EmployerDto = null;
  private isTmpEmployer = false;
  private employers$ = new BehaviorSubject<EmployerDto[]>([]);
  private employerConfig: EnterpriseConfigV2Dto = null;
  private employerConfig$ = new BehaviorSubject<EnterpriseConfigV2Dto>(null);
  private employerLicenses = null;
  private employerLicenses$ = new BehaviorSubject<EnterpriseLicensesV2Dto>(null);
  private employers: EmployerDto[] = [];
  private tmpEmployers: EmployerDto[] = [];
  private isInEnterpriseDashboard = false;
  private isInRetailerDashboard = false;

  private retailerConfig: RetailerConfigV2Dto = null;
  private retailerConfig$ = new BehaviorSubject<RetailerConfigV2Dto>(null);

  private employerEmployeeConfig: EmployeeConfigDto = null;
  private employerEmployeeConfig$ = new BehaviorSubject<EmployeeConfigDto>(null);

  constructor(
    private userEmpRest: EmployeeRestService,
    private auth: AuthService,
    private enterpriseService: EnterpriseRestService,
    private retailerService: RetailerRestService,
    private errorHandler: ErrorHandlerService,
    private employeeRest: EmployeeRestService,
    private router: Router,
    private log: NGXLogger
  ) {
    this.auth.onAuthenticate().subscribe((user) => {
      // this.refreshUserEmployers();
      if (user) {        
        this.userEmpRest.listEmployersUsingGET(user.username)
        .subscribe({
          next: (employers) => {
            if (employers.length > 0) {
              this.employers$.next(employers);
             this.handleEmployersResponse(employers);
            }
          },
          error: (err) => {
            this.handleEmployersError(err);
          }
        });
      }

     
      
      // const employers = this.employers$.getValue();
      // if (employers.length > 0) {        
      //   console.log('Employers:', employers);
        
      //   this.selectAppropriateEmployer(employers);
      // } else {
      //   this.resetEmployerData_();
      // }
      // if (user) {        
      //   this.setSelectedEmployer('');
      //   this.refreshUserEmployers();
      // }
      // else {
      //   this.refreshUserEmployers();
      //   const oldEmployer = this.selectedEmployer ? { ...this.selectedEmployer } : { username: '' };

      //   const matchingEmployers = this.findMatchingEmployers(empUserName);
        
      //   if (!matchingEmployers.length) {
      //     this.resetEmployerState();
      //     return;
      //   }
    
      //   this.initializeNewEmployer(matchingEmployers[0], isTmpEmployer);
      //   this.fetchEmployerData(empUserName, oldEmployer);
      // }
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Check if the url can be found in
        // one of the children of this item
      }
    });
  }

  private refreshUserEmployers(): Observable<EmployerDto[]> {
    const authenticatedUser = this.auth.getAuthenticatedUser() || this.auth.authUserData;
        
    if (!authenticatedUser) {
      this.resetEmployerData_();
      return this.employers$;
    }

    this.userEmpRest.listEmployersUsingGET(authenticatedUser.username)
      .subscribe({
        next: (employers) => {
          this.handleEmployersResponse(employers);
        },
        error: (err) => {
          this.handleEmployersError(err);
        }
      });
    
    return this.employers$;
  }

  private resetEmployerData_(): void {
    this.employers = [];
    this.tmpEmployers = [];
    this.employers$.next(this.employers);
    this.setSelectedEmployer('');
  }

  private handleEmployersResponse(employers: EmployerDto[]): void {
    this.employers = employers;
    
    if (employers.length > 0) {
      
      this.selectAppropriateEmployer(employers);
    }
    
    this.employers$.next(this.employers);
  }

  private selectAppropriateEmployer(employers: EmployerDto[]): void {        
    if (!this.selectedEmployer) {
      
      const activeEmployer = employers.find(emp => emp.state === 'ACTIVE');
      if (activeEmployer) {
        
        this.setSelectedEmployer(activeEmployer.username, null);
      }
    } else {

      this.setSelectedEmployer(this.selectedEmployer.username, this.selectedEmployer);
    }
  }

  private handleEmployersError(err: any): void {
    this.resetEmployerData();
    this.errorHandler.handleHttpError(err);
  }

  onGetEmployers(): Observable<EmployerDto[]> {
    return this.employers$;
  }

  getEmployers(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.onGetEmployers().subscribe(
        (result) => {
          // Success
          resolve();
        },
        (err) => {
          this.errorHandler.handleResponseError(err);
          reject(err);
        }
      );
    });
  }

  onGetEmployerConfig(): Observable<EnterpriseConfigV2Dto> {
    return this.employerConfig$;
  }

  refreshEmployerConfig() {
    if (this.selectedEmployer && this.selectedEmployer.type === EnterpriseTypeEnum.ENTERPRISE) {
      this.enterpriseService.getConfigurationEnterpriseUsingGET(this.selectedEmployer.username).subscribe((config) => {
        this.employerConfig = config;
        this.employerConfig$.next(this.employerConfig);
      });
    }
  }

  onGetRetailerConfig(): Observable<RetailerConfigV2Dto> {
    return this.retailerConfig$;
  }

  /**
   * return the selected employer always when clicked
   */
  onSelectEmployer(): Observable<EmployerDto> {
    return this.selectedEmployer$;
  }
  /**
   * return the licenses for the selected employer
   */
  onActivatedLicensesChanged(): Observable<EnterpriseLicensesV2Dto> {
    return this.employerLicenses$;
  }

  refreshActivatedLicenses() {
    if (this.selectedEmployer && this.selectedEmployer.type === EnterpriseTypeEnum.ENTERPRISE) {
      this.enterpriseService.getActivatedLicensesUsingGET(this.selectedEmployer.username).subscribe((licenses) => {
        this.employerLicenses = licenses;
        this.employerLicenses$.next(this.employerLicenses);
      });
    }
  }

  addTemporaryEmployer(enterprise: EnterpriseDto) {
    this.tmpEmployers.push(enterprise);
  }

  isTemporaryEmployer(): boolean {
    return this.isTmpEmployer;
  }

  setSelectedEmployer(empUserName: string, employer?: EmployerDto, isTmpEmployer: boolean = false): void {    
    // only trigger, if employer changed
    if(!this.selectedEmployer || empUserName != this.selectedEmployer.username || employer){
      let matchingEmployers = this.employers.filter(emp => emp.username === empUserName);
      if(this.auth.hasGrant(ExaGrant.ADMIN) && matchingEmployers.length !== 1){
          // also check the tmpEmployers
          matchingEmployers = this.tmpEmployers.filter(emp => emp.username === empUserName);
      }
      if (matchingEmployers.length === 1) {
        
        // the selected employer is not null
        // Mark the old selected employer
        let oldEmployer = { username: '' };
        Object.assign(oldEmployer, this.selectedEmployer);
        // Set the selected employer
        this.selectedEmployer = matchingEmployers[0];
        this.employerConfig = null;
        this.retailerConfig = null;
        this.employerLicenses = null;
        this.employerEmployeeConfig = null;

        if(isTmpEmployer != null){
          this.isTmpEmployer = isTmpEmployer;
        }else{
          this.isTmpEmployer = false;
        }

        if(this.selectedEmployer.type == EnterpriseTypeEnum.RETAILER){
          this.retailerService.getConfigurationUsingGET(empUserName).subscribe(reteilerConfig => {
            this.retailerConfig = reteilerConfig;
            this.employerConfig$.next(this.employerConfig);
            this.retailerConfig$.next(this.retailerConfig);
            this.employerLicenses$.next(this.employerLicenses);
            this.employerEmployeeConfig$.next(this.employerEmployeeConfig);
            this.selectedEmployer$.next(this.selectedEmployer);
            this.selectedEmployerFirst$.next(this.selectedEmployer);
            
    
            this.switchPageToDashboardConditionalRetailer(oldEmployer, this.selectedEmployer);
          },
          err => {
            this.employerConfig = null;
            this.retailerConfig = null;
            this.employerLicenses = null;
            this.employerConfig$.next(this.employerConfig);
            this.retailerConfig$.next(this.retailerConfig);
            this.employerLicenses$.next(this.employerLicenses);
            this.employerEmployeeConfig$.next(this.employerEmployeeConfig);
            this.errorHandler.handleResponseError(err);
          });
        }else{
          let arr = null;
          if(this.isTmpEmployer){
            arr = [this.enterpriseService.getConfigurationEnterpriseUsingGET(empUserName),
            this.enterpriseService.getActivatedLicensesUsingGET(empUserName)
            ];
          }else{
            arr = [this.enterpriseService.getConfigurationEnterpriseUsingGET(empUserName),
              this.enterpriseService.getActivatedLicensesUsingGET(empUserName),
              this.employeeRest.getConfigurationEmployeeUsingGET(empUserName)
            ];
          }
          forkJoin(
            arr
          ).subscribe(
            data => {
              this.employerConfig = data[0];
              this.employerConfig$.next(data[0]);
              this.retailerConfig$.next(this.retailerConfig);
              this.employerLicenses = data[1];
              this.employerLicenses$.next(data[1]);
              if(this.isTmpEmployer){
                this.employerEmployeeConfig$.next(this.employerEmployeeConfig);
              }else{
                this.employerEmployeeConfig = data[2];
                this.employerEmployeeConfig$.next(data[2]);
              }

              this.selectedEmployer$.next(this.selectedEmployer);
              this.selectedEmployerFirst$.next(this.selectedEmployer);

              
          this.switchPageToDashboardConditional(oldEmployer, this.selectedEmployer);
              
              // this.switchPageToDashboardConditional(this.selectedEmployer);
            },
            err => {
              this.employerConfig = null;
              this.retailerConfig = null;
              this.employerLicenses = null;
              this.employerConfig$.next(this.employerConfig);
              this.retailerConfig$.next(this.retailerConfig);
              this.employerLicenses$.next(this.employerLicenses);
              this.employerEmployeeConfig$.next(this.employerEmployeeConfig);
              this.errorHandler.handleResponseError(err);
            }
          );
        }
      } else {
        
        this.selectedEmployer = null;
        this.selectedEmployer$.next(this.selectedEmployer);
        this.selectedEmployerFirst$.next(this.selectedEmployer);
        this.employerConfig$.next(null);
        this.employerLicenses$.next(null);
        this.employerEmployeeConfig$.next(this.employerEmployeeConfig);
        // this.log.debug(this.className + ' employer null');
        this.switchPageToDashboardConditional(null, this.selectedEmployer);
        // this.switchPageToDashboardConditional(this.selectedEmployer);
      }
    }
    if(employer && this.selectedEmployer && empUserName === this.selectedEmployer.username) {
      this.selectedEmployer = null;
      this.selectedEmployer$.next(this.selectedEmployer);
      this.selectedEmployerFirst$.next(this.selectedEmployer);
      this.employerConfig$.next(null);
      this.employerLicenses$.next(null);
      this.employerEmployeeConfig$.next(this.employerEmployeeConfig);
      // this.log.debug(this.className + ' employer null');
      this.switchPageToDashboardConditional(null, this.selectedEmployer);

    }
    





    // // Skip if same employer is already selected
    // if (this.selectedEmployer === employer) {
    //   return;
    // }

    // // Store current employer state before changes
    // const previousEmployer = this.selectedEmployer ? 
    //   { ...this.selectedEmployer } : 
    //   { username: '' };

    // // Find matching employers and handle no matches
    // const matches = this.findMatchingEmployers(empUserName);
    // if (!matches.length) {
    //   this.resetEmployerState();
    //   return;
    // }
    // else {      
    //     // Set new employer and fetch related data
    // const [newEmployer] = matches;
    // this.initializeNewEmployer(newEmployer, isTmpEmployer);
    // this.fetchEmployerData(empUserName, previousEmployer);
    // }
  
  }

  private findMatchingEmployers(empUserName: string): EmployerDto[] {
    let matches = this.employers.filter(emp => emp.username === empUserName);    
    
    if (this.auth.hasGrant(ExaGrant.ADMIN) && !matches.length) {
      matches = this.tmpEmployers.filter(emp => emp.username === empUserName);
    }
    return matches;
  }

  private initializeNewEmployer(employer: EmployerDto, isTmpEmployer: boolean) {
    this.selectedEmployer = employer;
    this.selectedEmployer$.next(employer);
    this.isTmpEmployer = isTmpEmployer;
    this.resetEmployerData();
  }

  private resetEmployerData() {
    this.employerConfig = null;
    this.retailerConfig = null;
    this.employerLicenses = null;
    this.employerEmployeeConfig = null;
  }

  private resetEmployerState() {
    this.selectedEmployer = null;
    this.resetEmployerData();
    this.updateSubscribers();
  }

  private fetchEmployerData(empUserName: string, oldEmployer: EmployerDto) {
    if (this.selectedEmployer.type === EnterpriseTypeEnum.RETAILER) {
      this.fetchRetailerData(empUserName, oldEmployer);
    } else {
      this.fetchEnterpriseData(empUserName, oldEmployer);
    }
  }

  private fetchRetailerData(empUserName: string, oldEmployer: EmployerDto) {
    this.retailerService.getConfigurationUsingGET(empUserName).subscribe({
      next: (retailerConfig) => {
        this.retailerConfig = retailerConfig;
        this.updateSubscribers();
        // this.router.navigate([NavUrls.DASHBOARD_MAP]);
        this.switchPageToDashboardConditionalRetailer(oldEmployer, this.selectedEmployer);
      },
      error: (err) => {
        this.handleError(err);
      }
    });
  }

  private fetchEnterpriseData(empUserName: string, oldEmployer: EmployerDto) {
    const requests = this.getEnterpriseRequests(empUserName);
    
    forkJoin(requests).subscribe({
      next: (data) => {
        this.updateEnterpriseData(data);
        this.updateSubscribers();
        // this.router.navigate([NavUrls.DASHBOARD_MAP]);
        this.switchPageToDashboardConditional(oldEmployer, this.selectedEmployer);
      },
      error: (err) => {
        this.handleError(err);
      }
    });
  }

  private getEnterpriseRequests(empUserName: string) {
    const baseRequests = [
      this.enterpriseService.getConfigurationEnterpriseUsingGET(empUserName),
      this.enterpriseService.getActivatedLicensesUsingGET(empUserName)
    ];

    return this.isTmpEmployer ? baseRequests : 
      [...baseRequests, this.employeeRest.getConfigurationEmployeeUsingGET(empUserName)];
  }

  private updateEnterpriseData(data: any[]) {
    this.employerConfig = data[0];
    this.employerLicenses = data[1];
    if (!this.isTmpEmployer) {
      this.employerEmployeeConfig = data[2];
    }
  }

  private updateSubscribers() {
    // this.selectedEmployer$ =  new BehaviorSubject<EmployerDto>(this.selectedEmployer);
    
    this.selectedEmployer$.next(this.selectedEmployer);
    this.selectedEmployerFirst$.next(this.selectedEmployer);
    this.employerConfig$.next(this.employerConfig);
    this.retailerConfig$.next(this.retailerConfig);
    this.employerLicenses$.next(this.employerLicenses);
    this.employerEmployeeConfig$.next(this.employerEmployeeConfig);
  }

  private handleError(err: any) {
    this.resetEmployerData();
    this.updateSubscribers();
    this.errorHandler.handleHttpError(err);
  }

  getEmployerConfig(): EnterpriseConfigV2Dto {
    return this.employerConfig;
  }

  isCurrentEmployerRetailer(): boolean {
    if (this.selectedEmployer) {
      return this.selectedEmployer.type === EnterpriseTypeEnum.RETAILER;
    }
    return false;
  }

  hasMinimumGrantForCurrentEmployer(grant: ExaGrant): boolean {
    if (this.selectedEmployer) {
      return this.auth.hasGrantOwner(grant, this.selectedEmployer.id);
    }
    return false;
  }

  hasAdditionalLicense(license: LicenseAdditionalEnum): boolean {
    if (this.employerLicenses) {
      switch (license) {
        case LicenseAdditionalEnum.SILO:
          if (this.employerLicenses.silo) {
            return true;
          }
          break;
        case LicenseAdditionalEnum.SYREN:
          if (this.employerLicenses.syren) {
            return true;
          }
          break;
      }
    }
    return false;
  }

  hasRetailerLiveStatusAllowed(): boolean {
    if (this.retailerConfig) {
      return this.retailerConfig.liveStatusAllowed;
    }
    return false;
  }

  hasRetailerGrant(grant: ExaGrant): boolean {
    if (this.retailerConfig) {
      return this.retailerConfig.accessRights.includes(grant);
    }
    return false;
  }

  hasPartnerConnection() {
    if (this.employerConfig) {
      return this.employerConfig.activePartnerConnections.length > 0;
    }
    return false;
  }

  getPartnerConnections() {
    if (this.employerConfig) {
      return this.employerConfig.activePartnerConnections;
    }
    return [];
  }

  hasPartnerConnectionType(pctype: PartnerConnectionTypEnum) {
    if (this.hasPartnerConnection()) {
      // check if the given pctype is in the list
      for (const pc of this.employerConfig.activePartnerConnections) {
        if (pc.type === pctype) {
          return true;
        }
      }
    }
    return false;
  }

  onEmployeeConfigChanged(): Observable<EmployeeConfigDto> {
    return this.employerEmployeeConfig$;
  }

  getEmployeeConfiguration(): EmployeeConfigDto {
    return this.employerEmployeeConfig;
  }

  updateEmployeeConfig(config: EmployeeConfigDto): Observable<null> {
    this.employerEmployeeConfig = config;
    return this.employeeRest.updateConfigurationEmployeeUsingPUT(config.employeeUsername, config.employerUsername, config);
  }
  /**
   * private Methods
   */
  private switchPageToDashboardConditional(oldEmployer: EmployerDto, newEmployer: EmployerDto) {
    const shouldSwitchPage = !this.isInEnterpriseDashboard && 
      (!oldEmployer || oldEmployer.username !== newEmployer.username || oldEmployer.username === '');

    if (shouldSwitchPage) {
      this.router.navigate([NavUrls.DASHBOARD_MAP]);
    }
  }

  private switchPageToDashboardConditionalRetailer(oldEmployer: EmployerDto, newEmployer: EmployerDto) {    
    if (!this.isInRetailerDashboard && 
        (!oldEmployer || oldEmployer.username !== newEmployer.username || oldEmployer.username === '')) {
      this.router.navigate([NavUrls.DASHBOARD_MAP]);
    }
  }
}
